import { Reveal } from "@/lib/motion";
import { LeadForm } from "@/components/site/LeadForm";
import { IMAGES } from "@/lib/images";

export const Contact = () => (
  <section id="kontakt" className="relative py-16 md:py-24">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <div>
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-[#FF6B6B]">Kontakt</span>
          <h2 className="font-display font-light text-5xl md:text-7xl mt-6 leading-[0.9]">
            Zacznij <span className="italic text-[#FF6B6B]">dzisiaj</span>.
          </h2>
          <p className="mt-8 text-muted text-lg leading-relaxed max-w-md">
            Zostaw imię i numer telefonu. Oddzwonię w ciągu 24 godzin, porozmawiamy o Twoim celu i
            umówimy pierwszy trening. Bez zobowiązań.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-12 relative overflow-hidden clip-frame h-56 hidden lg:block">
            <img
              src={IMAGES.gym}
              alt="Zdrofit Stegny"
              className="w-full h-full object-cover grayscale"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F0E0E] to-transparent" />
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <LeadForm source="contact-section" />
      </Reveal>
    </div>
  </section>
);
